// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__container {
  display: flex;
  padding: 5px;
  height: 100%;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__rightContainer {
  flex: 5 1 auto;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__leftContainer {
  padding: 5px;
  height: 100%;
  overflow-y: auto;
  min-width: 600px;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__AttributesBlockContainer {
  max-width: 100%;
  width: 100%;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__expandableList {
  background-color: #ffffff;
  border: 1px solid #e8e8e8;
  min-width: 550px;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__expandableListItem-border {
  border-bottom: 1px solid #e8e8e8;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__tableNameContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: nowrap;
  padding: 15px;
  height: 55px;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__tableTitle {
  display: flex;
  flex-direction: row;
  align-content: center;
  align-items: center;
  flex-wrap: nowrap;
  font-weight: bold;
  font-size: 20px;
  line-height: 20px;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__viewTableButton {
  border-radius: 4px;
  padding: 5px;
  color: var(--colors-mainColor);
  cursor: pointer;
  transition: 0.3s;
  font-size: 15px;
  margin: 0 7px;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__viewTableButton:hover {
  border-radius: 4px;
  background-color: var(--colors-mainColor);
  color: #ffffff;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__tableType {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__tableTypeLabel {
  line-height: 18px;
  font-size: 18px;
  margin-left: 4px;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__TopToolbarContainer {
  max-height: 50px;
  padding: 10px;
  border: 1px solid #e8e8e8;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__stepItemContainer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  margin: 2px 10px 2px 0;
  padding: 5px;
  border-radius: 5px;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__stepItemContainer:hover {
  background-color: rgba(0, 0, 0, 0.03);
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__stepLabel {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__searchInputContainer {
  display: flex;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__searchInput {
  width: 300px;
  margin-bottom: 10px;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__noItem {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__scrollBox {
  overflow-y: auto;
  max-height: 170px;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__itemSubLabel {
  color: #bbbbbb;
  margin-left: 6px;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__iconContainer {
  border-radius: 4px;
  margin-right: 3px;
  padding: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  color: #4a4a4a;
}

.app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__iconContainer:hover {
  background-color: #4a4a4a;
  color: #ffffff;
}
`, "",{"version":3,"sources":["webpack://./app/pages/Project/Settings/FollowUp/SettingsFollowUp.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB","sourcesContent":[".container {\n  display: flex;\n  padding: 5px;\n  height: 100%;\n}\n\n.rightContainer {\n  flex: 5 1 auto;\n}\n\n.leftContainer {\n  padding: 5px;\n  height: 100%;\n  overflow-y: auto;\n  min-width: 600px;\n}\n\n.AttributesBlockContainer {\n  max-width: 100%;\n  width: 100%;\n}\n\n.expandableList {\n  background-color: #ffffff;\n  border: 1px solid #e8e8e8;\n  min-width: 550px;\n}\n\n.expandableListItem-border {\n  border-bottom: 1px solid #e8e8e8;\n}\n\n.tableNameContainer {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  flex-wrap: nowrap;\n  padding: 15px;\n  height: 55px;\n}\n\n.tableTitle {\n  display: flex;\n  flex-direction: row;\n  align-content: center;\n  align-items: center;\n  flex-wrap: nowrap;\n  font-weight: bold;\n  font-size: 20px;\n  line-height: 20px;\n}\n\n.viewTableButton {\n  border-radius: 4px;\n  padding: 5px;\n  color: var(--colors-mainColor);\n  cursor: pointer;\n  transition: 0.3s;\n  font-size: 15px;\n  margin: 0 7px;\n}\n\n.viewTableButton:hover {\n  border-radius: 4px;\n  background-color: var(--colors-mainColor);\n  color: #ffffff;\n}\n\n.tableType {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n}\n\n.tableTypeLabel {\n  line-height: 18px;\n  font-size: 18px;\n  margin-left: 4px;\n}\n\n.TopToolbarContainer {\n  max-height: 50px;\n  padding: 10px;\n  border: 1px solid #e8e8e8;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-content: center;\n  align-items: center;\n}\n\n.stepItemContainer {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  margin: 2px 10px 2px 0;\n  padding: 5px;\n  border-radius: 5px;\n}\n\n.stepItemContainer:hover {\n  background-color: rgba(0, 0, 0, 0.03);\n}\n\n.stepLabel {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.searchInputContainer {\n  display: flex;\n}\n\n.searchInput {\n  width: 300px;\n  margin-bottom: 10px;\n}\n\n.noItem {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-content: center;\n}\n\n.scrollBox {\n  overflow-y: auto;\n  max-height: 170px;\n}\n\n.itemSubLabel {\n  color: #bbbbbb;\n  margin-left: 6px;\n}\n\n.iconContainer {\n  border-radius: 4px;\n  margin-right: 3px;\n  padding: 5px;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-content: center;\n  align-items: center;\n  color: #4a4a4a;\n}\n\n.iconContainer:hover {\n  background-color: #4a4a4a;\n  color: #ffffff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__container`,
	"rightContainer": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__rightContainer`,
	"leftContainer": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__leftContainer`,
	"AttributesBlockContainer": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__AttributesBlockContainer`,
	"expandableList": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__expandableList`,
	"expandableListItem-border": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__expandableListItem-border`,
	"tableNameContainer": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__tableNameContainer`,
	"tableTitle": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__tableTitle`,
	"viewTableButton": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__viewTableButton`,
	"tableType": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__tableType`,
	"tableTypeLabel": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__tableTypeLabel`,
	"TopToolbarContainer": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__TopToolbarContainer`,
	"stepItemContainer": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__stepItemContainer`,
	"stepLabel": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__stepLabel`,
	"searchInputContainer": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__searchInputContainer`,
	"searchInput": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__searchInput`,
	"noItem": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__noItem`,
	"scrollBox": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__scrollBox`,
	"itemSubLabel": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__itemSubLabel`,
	"iconContainer": `app-pages-Project-Settings-FollowUp-___SettingsFollowUp-module__iconContainer`
};
export default ___CSS_LOADER_EXPORT___;
